
var dawn = [
    "/Textures/Dawn/Dawn_px.jpg",
    "/Textures/Dawn/Dawn_py.jpg",
    "/Textures/Dawn/Dawn_pz.jpg",
    "/Textures/Dawn/Dawn_nx.jpg",
    "/Textures/Dawn/Dawn_ny.jpg",
    "/Textures/Dawn/Dawn_nz.jpg",
];

var daylight = [
    "/Textures/Daylight/Daylight_px.jpg",
    "/Textures/Daylight/Daylight_py.jpg",
    "/Textures/Daylight/Daylight_pz.jpg",
    "/Textures/Daylight/Daylight_nx.jpg",
    "/Textures/Daylight/Daylight_ny.jpg",
    "/Textures/Daylight/Daylight_nz.jpg",
];

var desert = [
    "/Textures/Desert/Desert_px.jpg",
    "/Textures/Desert/Desert_py.jpg",
    "/Textures/Desert/Desert_pz.jpg",
    "/Textures/Desert/Desert_nx.jpg",
    "/Textures/Desert/Desert_ny.jpg",
    "/Textures/Desert/Desert_nz.jpg",
];

var dusk = [
    "/Textures/Dusk/Dusk_px.jpg",
    "/Textures/Dusk/Dusk_py.jpg",
    "/Textures/Dusk/Dusk_pz.jpg",
    "/Textures/Dusk/Dusk_nx.jpg",
    "/Textures/Dusk/Dusk_ny.jpg",
    "/Textures/Dusk/Dusk_nz.jpg",
];

var nighttime = [
    "/Textures/Nighttime/Nighttime_px.jpg",
    "/Textures/Nighttime/Nighttime_py.jpg",
    "/Textures/Nighttime/Nighttime_pz.jpg",
    "/Textures/Nighttime/Nighttime_nx.jpg",
    "/Textures/Nighttime/Nighttime_ny.jpg",
    "/Textures/Nighttime/Nighttime_nz.jpg",
];

var offshore = [
    "/Textures/Offshore/Offshore_px.jpg",
    "/Textures/Offshore/Offshore_py.jpg",
    "/Textures/Offshore/Offshore_pz.jpg",
    "/Textures/Offshore/Offshore_nx.jpg",
    "/Textures/Offshore/Offshore_ny.jpg",
    "/Textures/Offshore/Offshore_nz.jpg",
];

export default {
    Offshore: offshore,
    Dawn: dawn,
    Daylight: daylight,
    Desert: desert,
    Dusk: dusk,
    Nighttime: nighttime
}
